import Vue from "vue";
import Vuex from "vuex";
import { VUEX_FLAG } from "./flag";
import { getItem, getPeriod } from "@/utils/";

Vue.use(Vuex);

const state = {
  accountLoginUser: getItem("accountLoginUser") || null,
  accountPeriod: getPeriod() || "",
  accountCompany: getItem("accountCompany") || null,
  accountInvoiceMsg: getItem("accountInvoiceMsg") || null,
  accountPeriodFlag: Boolean(getItem("saveAccountPeriodFlag")) || false,
  showConfirmAccountCompany:
    Boolean(getItem("saveShowConfirmAccountCompany")) || false,
};

const getters = {
  getAccountLoginUser: (state, getters) => {
    return state.accountLoginUser;
  },
  getAccountPeriod: (state, getters) => {
    return state.accountPeriod;
  },
  getAccountCompany: (state, getters) => {
    return state.accountCompany;
  },
  getAccountInvoiceMsg: (state, getters) => {
    return state.accountInvoiceMsg;
  },
  getAccountPeriodFlag: (state, getters) => {
    return state.accountPeriodFlag;
  },
  getShowConfirmAccountCompany: (state, getters) => {
    return state.showConfirmAccountCompany;
  },
};

const actions = {
  setAccountLoginUser({ commit, state }, accountLoginUser) {
    commit(VUEX_FLAG.SET_ACCOUNT_LOGIN_USER, accountLoginUser);
  },
  setAccountPeriod({ commit, state }, accountPeriod) {
    commit(VUEX_FLAG.SET_ACCOUNT_PERIOD, accountPeriod);
  },
  setAccountCompany({ commit, state }, accountCompany) {
    commit(VUEX_FLAG.SET_ACCOUNT_COMPANY, accountCompany);
  },
  setAccountInvoiceMsg({ commit, state }, accountInvoiceMsg) {
    commit(VUEX_FLAG.SET_ACCOUNT_INVOICEMSG, accountInvoiceMsg);
  },
  setAccountPeriodFlag({ commit, state }, accountPeriodFlag) {
    commit(VUEX_FLAG.SET_ACCOUNT_PERIOD_FLAG, accountPeriodFlag);
  },
  setShowConfirmAccountCompany({ commit, state }, showConfirmAccountCompany) {
    commit(VUEX_FLAG.SHOW_CONFIRM_ACCOUNT_COMPANY, showConfirmAccountCompany);
  },
};

const mutations = {
  [VUEX_FLAG.SET_ACCOUNT_LOGIN_USER](state, accountLoginUser) {
    state.accountLoginUser = null;
    state.accountLoginUser = accountLoginUser;
  },
  [VUEX_FLAG.SET_ACCOUNT_PERIOD](state, accountPeriod) {
    state.accountPeriod = "";
    state.accountPeriod = accountPeriod;
  },
  [VUEX_FLAG.SET_ACCOUNT_COMPANY](state, accountCompany) {
    state.accountCompany = null;
    state.accountCompany = accountCompany;
  },
  [VUEX_FLAG.SET_ACCOUNT_INVOICEMSG](state, accountInvoiceMsg) {
    state.accountInvoiceMsg = null;
    state.accountInvoiceMsg = accountInvoiceMsg;
  },
  [VUEX_FLAG.SET_ACCOUNT_PERIOD_FLAG](state, accountPeriodFlag) {
    state.accountPeriodFlag = null;
    state.accountPeriodFlag = accountPeriodFlag;
  },
  [VUEX_FLAG.SHOW_CONFIRM_ACCOUNT_COMPANY](state, showConfirmAccountCompany) {
    state.showConfirmAccountCompany = null;
    state.showConfirmAccountCompany = showConfirmAccountCompany;
  },
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});

// const store = new Vuex.Store({
//   state,
//   getters,
//   actions,
//   mutations
// })

// export { store }



// WEBPACK FOOTER //
// ./src/store/index.js